import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";

interface PropData {
    id: number;
  showModal?: boolean;
  title : string
  onCloseModel?: (isClose: boolean) => void;
}

const UserDeleteModal = (props: PropData) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onConfirmDelete = async () => {
    setLoading(true);
    try {

      const res = await WebService.deleteAPI({
        action: `/user/delete/${props.id}`,
        body: null,
      });

      if (res) {
        toast.success("User deleted successfully.");
        closeModal();
      }
    } catch (e: any) {
      toast.error(e?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    props.onCloseModel?.(false);
  };

  return (
    <Modal show={props.showModal} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title className="font-18">{props.title || "Confirmation"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div><IoIosCloseCircleOutline size={70} color="#f15e5e" /></div>
        <div className="font-16 pt-2">Are you sure you want to delete?</div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center pt-2 border-top-0">
        <Button variant="outline-primary me-3" onClick={closeModal} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirmDelete} disabled={loading}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserDeleteModal;
